import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getIsLoading = (state) => get(state, 'locations.isLoading', false);
export const getIsSaving = (state) => get(state, 'locations.isSaving', false);
export const getVisibleLocations = (state) => get(state, 'locations.locations', []);



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/selectors/locations_selectors.js